import { render, staticRenderFns } from "./UserInfoRoute.vue?vue&type=template&id=19185075&"
import script from "./UserInfoRoute.vue?vue&type=script&lang=js&"
export * from "./UserInfoRoute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports